import {
    CheckCircleRounded as CheckCircleIcon,
    PixRounded as PixRoundedIcon,
    CreditCardRounded as CreditCardRoundedIcon,
} from '@mui/icons-material'

import {paymentMethods as textsPaymentMethods} from '../../../translate/Translate.jsx'
import {motion} from 'framer-motion'

import {getLocal} from '../../../hooks/useStorage/useStorage.jsx'

import './paymentTypes.scss'

const PaymentTypes = ({onClick}) => {

    const pix = getLocal('pix')
    const onlinePayments = getLocal('onlinePayments')

    return <motion.div
        initial={{x: 400}}
        animate={{x: 0}}
        exit={{x: 400, opacity: 0}}
        transition={{duration: 0.3}}>
        <div className={'payments-types'}>
            <div className={'div-payments-types'}>
                <div className={'div-title'}>
                    <label className={'label-title-payments-types'}>
                        {textsPaymentMethods.onlinePayment}
                    </label>
                </div>
                {(pix) && <div className={'div-types'}>
                    <div className={'div-item-types'} onClick={() => {
                        onClick({code: 'PIX', description: 'Pix', online: 'True'})
                    }}>
                        <div className={'div-description-type'}>
                            <PixRoundedIcon className={'icon-pix'}/>
                            <label className={'label-description-payments-types'}>
                                PIX
                            </label>
                        </div>
                        <div className={'div-seleted-type'}>
                            <CheckCircleIcon className={'icon-select-option'}/>
                        </div>
                    </div>
                </div>}
                {(onlinePayments) && <div className={'div-types'} onClick={() => {
                    onClick({code: 'ONLINE', description: 'Pagamento Online', online: 'True'})
                }}>
                    <div className={'div-item-types'}>
                        <div className={'div-description-type'}>
                            <CreditCardRoundedIcon className={'icon-payment-online'}/>
                            <label className={'label-description-payments-types'}>
                                Pagamento online
                            </label>
                        </div>
                        <div className={'div-seleted-type'}>
                            <CheckCircleIcon className={'icon-select-option'}/>
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    </motion.div>
}

export default PaymentTypes
